var _style, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRotateDevice = function SvgIconRotateDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon_rotate_device_svg__Layer_1",
    width: "1em",
    height: "1em",
    x: 0,
    y: 0,
    viewBox: "0 0 270.2 215.6"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_rotate_device_svg__st1{fill:#9c9c9c}.icon_rotate_device_svg__st3{fill:#e9e9e9}.icon_rotate_device_svg__st7{fill:none;stroke:#000;stroke-width:5;stroke-linecap:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M3 201v-94c0-6.1 4.9-11 11-11h187c6.1 0 11 4.9 11 11v94c0 6.1-4.9 11-11 11H14c-6.1 0-11-4.9-11-11z",
    style: {
      fill: "#e9e9e9",
      stroke: "#9c9c9c",
      strokeWidth: 6
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 184v-59h9c1.7 0 3 1.3 3 3v53c0 1.7-1.3 3-3 3z",
    className: "icon_rotate_device_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193 178.5v-49c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v49c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5",
    style: {
      fill: "#747474"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 172.5,
    r: 8.5,
    className: "icon_rotate_device_svg__st1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 135.5,
    r: 8.5,
    className: "icon_rotate_device_svg__st1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 132.5,
    r: 3.5,
    className: "icon_rotate_device_svg__st3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 170.5,
    r: 3.5,
    className: "icon_rotate_device_svg__st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120 184c-17.5-9.5-23.5-46 0-60",
    style: {
      fill: "none",
      stroke: "#9c9c9c",
      strokeWidth: 7,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 3h94c6.1 0 11 4.9 11 11v187c0 6.1-4.9 11-11 11h-94c-6.1 0-11-4.9-11-11V14c0-6.1 4.9-11 11-11z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 6
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 0h59v9c0 1.7-1.3 3-3 3h-53c-1.7 0-3-1.3-3-3zM185 193h49c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-49c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.5 104.5c9.5 17.5 46 23.5 60 0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 7,
      strokeLinecap: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 66c3.2-5.7 15.3-7.6 20 0M220 66c3.2-5.7 15.3-7.6 20 0",
    className: "icon_rotate_device_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 24h66v66H75z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgIconRotateDevice;